document.addEventListener("DOMContentLoaded", function () {

  /*
   * =========================================================
   * SNAPPYLAYERS — CUSTOM KEYCHAIN BUY 1 GET 1
   * =========================================================
   *
   * When the customer adds the qualifying keychain:
   *
   * 1. Normal Add to Cart is temporarily stopped.
   * 2. BOGO popup appears.
   * 3. Customer can claim the offer.
   * 4. The EXACT SAME product + variant is added twice.
   *
   * No second customization is required.
   * =========================================================
   */

  const BOGO_KEYWORDS = [
    "custom keychain",
    "custom keyring",
    "number plate keychain",
    "number plate keyring"
  ];

  let pendingForm = null;
  let pendingVariantId = null;

  /*
   * ---------------------------------------------------------
   * CHECK WHETHER PRODUCT IS A KEYCHAIN
   * ---------------------------------------------------------
   */

  function isKeychainForm(form) {

    const productForm = form.closest("product-form");

    if (!productForm) return false;

    /*
     * Look for product title on the product page.
     */

    const titleElement =
      document.querySelector(".product__title h1") ||
      document.querySelector(".product__title") ||
      document.querySelector("h1.product__title") ||
      document.querySelector("h1");

    if (!titleElement) return false;

    const title = titleElement.textContent
      .trim()
      .toLowerCase();

    return BOGO_KEYWORDS.some(function (keyword) {
      return title.includes(keyword);
    });

  }


  /*
   * ---------------------------------------------------------
   * CREATE POPUP
   * ---------------------------------------------------------
   */

  function createPopup() {

    if (document.getElementById("sl-bogo-popup")) return;


    const popup = document.createElement("div");

    popup.id = "sl-bogo-popup";

    popup.innerHTML = `

      <div class="sl-bogo-overlay"></div>

      <div
        class="sl-bogo-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="sl-bogo-title"
      >

        <button
          type="button"
          class="sl-bogo-close"
          aria-label="Close"
        >
          ×
        </button>


        <div class="sl-bogo-icon">
          🎁
        </div>


        <div class="sl-bogo-eyebrow">
          LIMITED TIME OFFER
        </div>


        <h2 id="sl-bogo-title">
          Buy 1, Get 1 FREE
        </h2>


        <p class="sl-bogo-text">
          Get an identical second custom keychain
          absolutely FREE with your order.
        </p>


        <div class="sl-bogo-highlight">

          <strong>
            2 KEYCHAINS
          </strong>

          <span>
            for the price of 1
          </span>

        </div>


        <button
          type="button"
          class="sl-bogo-claim"
          id="sl-bogo-claim"
        >
          Claim Free Keychain
        </button>


        <button
          type="button"
          class="sl-bogo-skip"
          id="sl-bogo-skip"
        >
          No thanks, continue with 1
        </button>


        <p class="sl-bogo-note">
          Same design • Same number • Same customization
        </p>

      </div>

    `;


    document.body.appendChild(popup);


    /*
     * CLOSE
     */

    popup
      .querySelector(".sl-bogo-close")
      .addEventListener("click", closePopup);


    popup
      .querySelector(".sl-bogo-overlay")
      .addEventListener("click", closePopup);


    /*
     * SKIP
     */

    popup
      .querySelector("#sl-bogo-skip")
      .addEventListener("click", function () {

        closePopup();

        addProductToCart(1);

      });


    /*
     * CLAIM
     */

    popup
      .querySelector("#sl-bogo-claim")
      .addEventListener("click", function () {

        const button = this;

        button.disabled = true;

        button.textContent = "Adding Offer...";


        addProductToCart(2)
          .then(function () {

            closePopup();

            openCartDrawer();

          })
          .catch(function (error) {

            console.error(
              "SnappyLayers BOGO error:",
              error
            );

            button.disabled = false;

            button.textContent =
              "Claim Free Keychain";

          });

      });

  }


  /*
   * ---------------------------------------------------------
   * OPEN POPUP
   * ---------------------------------------------------------
   */

  function openPopup() {

    createPopup();

    const popup =
      document.getElementById("sl-bogo-popup");

    popup.classList.add("is-active");

    document.body.classList.add(
      "sl-bogo-active"
    );

  }


  /*
   * ---------------------------------------------------------
   * CLOSE POPUP
   * ---------------------------------------------------------
   */

  function closePopup() {

    const popup =
      document.getElementById("sl-bogo-popup");

    if (!popup) return;

    popup.classList.remove("is-active");

    document.body.classList.remove(
      "sl-bogo-active"
    );

  }


  /*
   * ---------------------------------------------------------
   * ADD PRODUCT
   * ---------------------------------------------------------
   */

  async function addProductToCart(quantity) {

    if (!pendingForm) {
      throw new Error("Product form not found.");
    }


    const formData =
      new FormData(pendingForm);


    /*
     * Force exact variant.
     */

    if (pendingVariantId) {

      formData.set(
        "id",
        pendingVariantId
      );

    }


    /*
     * Set quantity.
     *
     * This means:
     *
     * quantity = 1
     * OR
     * quantity = 2
     *
     * of the SAME variant.
     */

    formData.set(
      "quantity",
      quantity
    );


    /*
     * Shopify AJAX Add To Cart
     */

    const response = await fetch(
      window.Shopify.routes.root + "cart/add.js",
      {
        method: "POST",

        headers: {
          "Accept":
            "application/json"
        },

        body: formData
      }
    );


    if (!response.ok) {

      const error =
        await response.json()
          .catch(function () {
            return {};
          });

      throw new Error(
        error.description ||
        "Unable to add product."
      );

    }


    return await response.json();

  }


  /*
   * ---------------------------------------------------------
   * OPEN YOUR EXISTING CART DRAWER
   * ---------------------------------------------------------
   */

  async function openCartDrawer() {

    /*
     * Your existing sl-cart-drawer.js
     * listens for clicks on /cart.
     *
     * We trigger the cart link here.
     */

    const cartLink =
      document.querySelector(
        'a[href="/cart"], a[href^="/cart"]'
      );


    if (cartLink) {

      cartLink.click();

      return;

    }


    /*
     * Fallback
     */

    window.location.href =
      window.Shopify.routes.root + "cart";

  }


  /*
   * ---------------------------------------------------------
   * INTERCEPT ADD TO CART
   * ---------------------------------------------------------
   */

  document.addEventListener(
    "submit",
    function (event) {

      const form = event.target;


      if (
        !form.matches(
          'form[data-type="add-to-cart-form"]'
        )
      ) {
        return;
      }


      /*
       * Only activate for custom keychain.
       */

      if (!isKeychainForm(form)) {
        return;
      }


      /*
       * Prevent Shopify's normal Add To Cart.
       */

      event.preventDefault();

      event.stopImmediatePropagation();


      /*
       * Save form.
       */

      pendingForm = form;


      /*
       * Get currently selected variant.
       */

      const variantInput =
        form.querySelector(
          'input[name="id"]'
        );


      if (!variantInput) {

        console.error(
          "SnappyLayers BOGO: Variant ID not found."
        );

        return;

      }


      pendingVariantId =
        variantInput.value;


      /*
       * Show offer.
       */

      openPopup();

    },
    true
  );


  /*
   * ---------------------------------------------------------
   * ESCAPE KEY
   * ---------------------------------------------------------
   */

  document.addEventListener(
    "keydown",
    function (event) {

      if (
        event.key === "Escape"
      ) {

        closePopup();

      }

    }
  );

});